export const CatGptItemSets = {
  CATGPT_3A: 'CATGPT_3A',
  CATGPT_3B: 'CATGPT_3B',
  CATGPT_3C: 'CATGPT_3C',
  CATGPT_3A_EXTREME: 'CATGPT_3A_EXTREME',
  CATGPT_3B_EXTREME: 'CATGPT_3B_EXTREME',
  CATGPT_3C_EXTREME: 'CATGPT_3C_EXTREME',
};

export const Game = {
  ID: 'CATGPT',
  OPTIONS: [
    CatGptItemSets.CATGPT_3A,
    CatGptItemSets.CATGPT_3A_EXTREME,
    CatGptItemSets.CATGPT_3B,
    CatGptItemSets.CATGPT_3B_EXTREME,
    CatGptItemSets.CATGPT_3C,
    CatGptItemSets.CATGPT_3C_EXTREME,
  ],
};

export const CoinOpStatus = {
  FINALIZED: 'FINALIZED',
  PROCESSING: 'PROCESSING',
  STARTED: 'STARTED',
};

export const FinaleText = [
  'Generating finale...',
  'Crafting your outcome...',
  'Creating your destiny...',
  'Calculating your conclusion...',
  'Constructing your finale...',
  'Determining your fate...',
  'Formulating your ending...',
  'Designing your final outcome...',
  'Forging your conclusion...',
  'Plotting your ultimate destiny...',
];

export const ChooseText = [
  `Select your path (A, B, or C):`,
  `Make a decision (A, B, or C):`,
  `Which path will you take (A, B, or C)?`,
  `Pick your choice (A, B, or C):`,
  `Time to choose (A, B, or C):`,
  `Your destiny awaits (A, B, or C):`,
  `Decide your fate (A, B, or C):`,
  `Which way will you go (A, B, or C)?`,
  `It's up to you now (A, B, or C):`,
  `The choice is yours (A, B, or C):`,
  'Pick your poison (A, B, or C):',
  'Roll the dice and choose (A, B, or C):',
  'Make your bet (A, B, or C):',
  'Trust your luck (A, B, or C):',
  'Go all-in and decide (A, B, or C):',
  'Take a chance and select (A, B, or C):',
];

// Array of messages for generating adventure
const StartText = [
  'Forging your epic journey...',
  'Unleashing your epic tale...',
  'Crafting your wild adventure...',
  'Formulating your heroic quest...',
  'Generating your daring escapade...',
  'Plotting your thrilling odyssey...',
  'Creating your fantastical saga...',
  'Calculating your epic adventure...',
  'Constructing your action-packed journey...',
  'Designing your unforgettable expedition...',
];

export const randomStartText = () => StartText[Math.floor(Math.random() * StartText.length)];
export const randomFinalText = () => FinaleText[Math.floor(Math.random() * FinaleText.length)];
export const randomChooseText = () => ChooseText[Math.floor(Math.random() * ChooseText.length)];

export const GAME_STEPS = {
  DEPOSIT: 'deposit',
  SETTING: 'setting',
  GAME_START: 'game-start',
  GAME_STEP_1: 'game-step-1',
  GAME_STEP_2: 'game-step-2',
  GAME_CONCLUSION: 'game-conclusion',
  GAME_REWARD: 'game-reward',
};

export const Steps = [
  GAME_STEPS.DEPOSIT,
  // GAME_STEPS.GAME_START,
  GAME_STEPS.GAME_STEP_1,
  // GAME_STEPS.GAME_STEP_2,
  GAME_STEPS.GAME_CONCLUSION,
  GAME_STEPS.GAME_REWARD,
];

export const PromoPageDetail = {
  id: 'promo',
  name: 'Promo',
  icon: 'fa-shop',
  path: '/promos',
};

export const ShopHourPageDetail = {
  id: 'shop-hours',
  name: 'Shop Hours',
  icon: 'fa-clock',
  path: '/shop-hours',
  selectImageUrl: '/images/cats/15095.png',
};

export const AnnouncementsPageDetail = {
  id: 'announcements',
  name: 'Announcements',
  icon: 'fa-bullhorn',
  path: '/announcements',
};

export const RFFPageDetail = {
  id: 'rff',
  name: 'Risk Free Plays (RFPs)',
  icon: 'fa-coins',
  path: '/campaigns',
  selectImageUrl: '/images/cats/12687.png',
};

export const DozerPageDetail = {
  id: 'dozer',
  name: 'Dozer Rewards',
  icon: 'fa-gamepad',
  path: '/dozer',
  selectImageUrl: '/images/cats/3768.png',
};

export const FragmentsPageDetail = {
  id: 'fragments',
  name: 'Shop Points',
  icon: 'fa-gem',
  path: '/fragments',
};

export const ProfilePageDetail = {
  id: 'profile',
  name: 'KYC Profiles',
  icon: 'fa-shield-halved',
  path: '/kyc-profiles',
  selectImageUrl: '/images/cats/8338.png',
};

export const VipPageDetail = {
  id: 'vip',
  name: 'VIP',
  icon: 'fa-trophy',
  path: '/vip',
};

export const WaitlistPageDetail = {
  id: 'waitlist',
  name: 'Waitlist',
  icon: 'fa-list-check',
  path: '/waitlist',
};

export const Pages = [
  PromoPageDetail,
  ShopHourPageDetail,
  AnnouncementsPageDetail,
  RFFPageDetail,
  DozerPageDetail,
  FragmentsPageDetail,
  ProfilePageDetail,
  VipPageDetail,
  WaitlistPageDetail,
];

export const RewardType = {
  SOL: 'SOL',
  RFF: 'RFF',
  DOZER_COIN: 'DOZER_COIN',
  // PHYSICAL_ITEM: 'PHYSICAL_ITEM',
  DIGITAL_ITEM: 'DIGITAL_ITEM',
  NFT: 'NFT',
  // DISCORD_ITEM: 'DISCORD_ITEM',
  // DISCORD_NITRO: 'DISCORD_NITRO',
  USDC: 'USDC',
};

export const PromoType = {
  FRAGMENT: 'FRAGMENT',
  RAFFLE: 'RAFFLE',
  LOSER: 'LOSER',
  VIP: 'VIP',
  // The waitlist prize promo (TRU-1074): the box catalog + ledger. Dates,
  // waves, and tier bands live on the Waitlist tab, not here.
  WAITLIST: 'WAITLIST',
};

export const VipPromoKind = {
  TIER: 'TIER',
  LEADERBOARD: 'LEADERBOARD',
};

// Tier values on promos: a reward rung (BD/VIP/VVIP) for TIER promos; ALL for
// LEADERBOARD (Top-3) promos, which are tier-agnostic (global board).
export const VipTier = {
  BD: 'BD',
  VIP: 'VIP', // middle rung (TRU-1116)
  VVIP: 'VVIP',
  ALL: 'ALL',
};

// The reward rungs in ladder order, lowest first — the order every tier picker
// offers them in. ALL is deliberately absent: it is a leaderboard target, not a
// rung, and each picker adds it where it applies.
export const VipTierRungs = [VipTier.BD, VipTier.VIP, VipTier.VVIP];

// Display-only qualifying volume per VIP tier (TRU-819, Phase 1).
// NOTE: this is a label for the admin's reference only — actual qualification
// runs off atlantis `VipMinVolume`. The two are independent; if atlantis
// recalibrates (cf. TRU-800, TRU-1116), update these by hand. Configurable/editable
// is Phase 2 (TRU-491).
export const VipTierThresholdsSol = {
  BD: 300,
  VIP: 500,
  VVIP: 1000,
};

export const VipTierLabel = {
  BD: 'Big Degen',
  VIP: 'VIP',
  VVIP: 'VVIP',
};

// Nav restriction only (Owen). These wallets see the Waitlist tab alone.
// Holy and Spectator are full cats admins on every other page and are not in
// this list. waitlist-svc ACL is the real gate.
export const MINT_ONLY_WALLETS = [
  'SmsUYWFRxTtMZ6A1qw2AUYY1hcmsSGNBMTqCL7NJV7s', // Owen — invite mint only
];

export const isMintOnlyWallet = walletId =>
  typeof walletId === 'string' && MINT_ONLY_WALLETS.includes(walletId);

// Waitlist-tab mint operators: Owen, Holy, and Spectator. Holy and Spectator
// are mint-only on the Waitlist tab (waitlist-svc ADMIN_MINT_WALLETS, not
// ADMIN_WALLETS) and still full admins everywhere else in cats. This hide is
// defense-in-depth for Close + Grant, Grant Jelly, edit/create wave, and
// CSV/anti-sybil exports. Freeze is separate (canFreezeWaitlistEntries).
// waitlist-svc ACL is the real gate.
export const WAITLIST_MINT_ONLY_WALLETS = [
  ...MINT_ONLY_WALLETS,
  '4aoD4ZosrGxv1G6Wn1tRwkhiQHqck4r5gydzCycsLvbR', // Holy (full cats admin, waitlist mint-only)
  'HjJQrmMyngbbZaU4mBKRvNxjmrZPF32AWoexaPgMuzJd', // Spectator (same access as Holy)
];

export const isWaitlistMintOnlyWallet = walletId =>
  typeof walletId === 'string' && WAITLIST_MINT_ONLY_WALLETS.includes(walletId);

// UI flag for the card Enable/Disable control. Holy and Spectator are
// enable-only (other shop writes stay locked). ser dqx is on this list and
// remains a full admin, so he sees that control and keeps the full editor.
// Spectator has no Atlantis rights yet: the controls still render, and a
// 403 is expected until that ACL exists. This list does not grant it.
// Admin, Venom, and Gwen are full editors already and are not on this list.
export const SHOP_ITEM_ENABLE_WALLETS = [
  '4aoD4ZosrGxv1G6Wn1tRwkhiQHqck4r5gydzCycsLvbR', // Holy
  'HjJQrmMyngbbZaU4mBKRvNxjmrZPF32AWoexaPgMuzJd', // Spectator (UI only; Atlantis may 403)
  'dqxqw4UcxyyJ1yUQvT45Bgny9rNtzWJ6PtibK16sjgY', // ser dqx (full admin; enable control too)
];

export const canEnableShopItems = walletId =>
  typeof walletId === 'string' && SHOP_ITEM_ENABLE_WALLETS.includes(walletId);

// Omega can log in and use every other page. The shop is read-only: no
// enable, archive, edit, create, delete, or shop-hour write. Not a
// shop-enable wallet and not mint-only.
export const SHOP_READ_ONLY_WALLETS = [
  'CUiPcE9B6ouyFt24NPZDeYqqWFda2Q8myW5aAuLQybDk', // Omega
];

export const isShopReadOnlyWallet = walletId =>
  typeof walletId === 'string' && SHOP_READ_ONLY_WALLETS.includes(walletId);

// Full shop editor: every shop write, including enable/disable inside the
// item form. Holy and Spectator are waitlist-mint-only, so they are not
// full editors. Omega is read-only. Owen never reaches the shop.
export const isFullShopEditor = walletId =>
  typeof walletId === 'string' &&
  LEGAL_WALLETS.includes(walletId) &&
  !isMintOnlyWallet(walletId) &&
  !isWaitlistMintOnlyWallet(walletId) &&
  !isShopReadOnlyWallet(walletId);

// Holy and Spectator. ser dqx is on SHOP_ITEM_ENABLE and is a full editor,
// so this is false for him.
export const isShopEnableOnlyWallet = walletId =>
  canEnableShopItems(walletId) && !isFullShopEditor(walletId);

// Freeze, unfreeze, and bulk freeze. Explicit so a wallet that is merely
// not mint-only does not gain the buttons. Owen and Omega are off this list.
// Close + Grant, Grant Jelly, wave edits, and exports stay on
// isWaitlistMintOnlyWallet.
export const FREEZE_WAITLIST_WALLETS = [
  'venm6WMaDrLFXGkvEZ2swCfZcy5Rdoh1DThvUEn3aej', // Venom
  '4aoD4ZosrGxv1G6Wn1tRwkhiQHqck4r5gydzCycsLvbR', // Holy
  'HjJQrmMyngbbZaU4mBKRvNxjmrZPF32AWoexaPgMuzJd', // Spectator
  'GWGZ2kdCqMSS2fNUay2joLDWHkP87W9mAGbs6SjicEn', // Gwen
  '65bad9L17xwG7KLUseyCiMZxQjaJVukHJjwmxpqJuVFx', // Admin
  'AdminvY7YYHmPufRbJp4yw9ke5XP89BjSNgSB2DsvVWV', // Admin (second wallet, AdminvY7)
  'dqxqw4UcxyyJ1yUQvT45Bgny9rNtzWJ6PtibK16sjgY', // ser dqx
];

export const canFreezeWaitlistEntries = walletId =>
  typeof walletId === 'string' && FREEZE_WAITLIST_WALLETS.includes(walletId);

// Archive a KYC primary from the KYC Profiles tab. Explicit so a wallet that
// is merely not mint-only does not gain the button. Owen and Omega are off
// this list. Spectator can freeze waitlist entries and is not on this list.
// checkin-svc LEGAL_WALLETS is the real gate. ser dqx may receive 401 until
// that list includes him. This list does not grant the backend right.
export const ARCHIVE_KYC_PRIMARY_WALLETS = [
  'venm6WMaDrLFXGkvEZ2swCfZcy5Rdoh1DThvUEn3aej', // Venom
  '4aoD4ZosrGxv1G6Wn1tRwkhiQHqck4r5gydzCycsLvbR', // Holy
  'GWGZ2kdCqMSS2fNUay2joLDWHkP87W9mAGbs6SjicEn', // Gwen
  '65bad9L17xwG7KLUseyCiMZxQjaJVukHJjwmxpqJuVFx', // Admin
  'AdminvY7YYHmPufRbJp4yw9ke5XP89BjSNgSB2DsvVWV', // Admin (second wallet, AdminvY7)
  'dqxqw4UcxyyJ1yUQvT45Bgny9rNtzWJ6PtibK16sjgY', // ser dqx
];

export const canArchiveKycPrimaryWallet = walletId =>
  typeof walletId === 'string' && ARCHIVE_KYC_PRIMARY_WALLETS.includes(walletId);

// Release a stuck multiplayer RFP lock from wallet search. This mirrors
// aegis-svc BASE_LEGAL_WALLETS (the only wallets POST .../release accepts).
// Spectator, ser dqx, and Owen are on LEGAL_WALLETS and are not aegis admins.
// This list does not grant the backend right.
export const AEGIS_ADMIN_WALLETS = [
  'venm6WMaDrLFXGkvEZ2swCfZcy5Rdoh1DThvUEn3aej', // Venom
  'GWGZ2kdCqMSS2fNUay2joLDWHkP87W9mAGbs6SjicEn', // Gwen
  '4aoD4ZosrGxv1G6Wn1tRwkhiQHqck4r5gydzCycsLvbR', // Holy
  'CUiPcE9B6ouyFt24NPZDeYqqWFda2Q8myW5aAuLQybDk', // Omega
  '65bad9L17xwG7KLUseyCiMZxQjaJVukHJjwmxpqJuVFx', // Admin
  'AdminvY7YYHmPufRbJp4yw9ke5XP89BjSNgSB2DsvVWV', // Admin (second wallet, AdminvY7)
  'web3oUAjsGdv6QaAeDCqw1T3CqotoRjZFph8JYveWyp', // web3o
];

export const canReleaseStuckRfpLock = walletId =>
  typeof walletId === 'string' && AEGIS_ADMIN_WALLETS.includes(walletId);

// Required by archiveKycPrimaryWallet. The confirm dialog does not collect a
// reason; the handler rejects an empty one and rejects unknown keys.
export const KYC_ARCHIVE_REASON = 'Archived from the KYC Profiles tab';

export const KYC_ARCHIVE_DIALOG_TITLE = 'Archive Primary Wallet';

export const kycArchiveConfirmLine = walletId => `Archive this ${walletId} wallet?`;

// Blocked-state checklist. Edit the wording here. The player unlinks at
// app.degencoinflip.com/verify (multiplayer-dapp WalletManagement).
export const KYC_UNLINK_CHECKLIST = {
  lead: 'Ask the player to:',
  signIn: 'Sign in at app.degencoinflip.com/verify with this primary wallet.',
  remove: 'Remove these sub-wallets (trash icon):',
  recheck: 'Then click Re-check here.',
};

export const isLegalWallet = walletId =>
  typeof walletId === 'string' && LEGAL_WALLETS.includes(walletId);

// The console a wallet gets. A username that is not on LEGAL_WALLETS gets
// no pages, including a persisted session from a wallet that was removed.
// Nav-restricted wallets (Owen) see the Waitlist tab alone. Holy and
// Spectator keep every page. Other legal wallets get every page.
export const pagesForWallet = walletId => {
  if (!isLegalWallet(walletId)) return [];
  return isMintOnlyWallet(walletId) ? Pages.filter(page => page.path === '/waitlist') : Pages;
};

export const homePathForWallet = walletId => (isMintOnlyWallet(walletId) ? '/waitlist' : '/promos');

export const LEGAL_WALLETS = [
  'venm6WMaDrLFXGkvEZ2swCfZcy5Rdoh1DThvUEn3aej', // Venom
  '4aoD4ZosrGxv1G6Wn1tRwkhiQHqck4r5gydzCycsLvbR', // Holy
  'HjJQrmMyngbbZaU4mBKRvNxjmrZPF32AWoexaPgMuzJd', // Spectator
  'CUiPcE9B6ouyFt24NPZDeYqqWFda2Q8myW5aAuLQybDk', // Omega
  'GWGZ2kdCqMSS2fNUay2joLDWHkP87W9mAGbs6SjicEn', // Gwen
  '65bad9L17xwG7KLUseyCiMZxQjaJVukHJjwmxpqJuVFx', // Admin
  'AdminvY7YYHmPufRbJp4yw9ke5XP89BjSNgSB2DsvVWV', // Admin (second wallet, AdminvY7)
  'dqxqw4UcxyyJ1yUQvT45Bgny9rNtzWJ6PtibK16sjgY', // ser dqx
  'SmsUYWFRxTtMZ6A1qw2AUYY1hcmsSGNBMTqCL7NJV7s', // Owen — invite mint only
];
